import FullMediaTextBox from './FullMediaTextBox';
import DoubleImageText from './DoubleImageText';
import DualFeature from './DualFeature';

export default async function Editorial({ block, position }) {
  const { modular_blocks: blocks } = block?.editorial?.reference?.[0] ?? {};
  if (!blocks || blocks.length === 0) {
    return null;
  }

  return blocks.map((block, index) => {
    switch (Object.keys(block)[0]) {
      case 'double_image_text':
        return (
          <DoubleImageText
            key={index}
            position={position}
            block={block.double_image_text}
          />
        );
      case 'dual_feature':
        return (
          <DualFeature
            key={index}
            position={position}
            block={block.dual_feature}
          />
        );
      case 'full_media_textbox':
        return (
          <FullMediaTextBox
            key={index}
            position={position}
            block={block.full_media_textbox}
          />
        );
      default:
        return <div key={index} className="empty-component"></div>;
    }
  });
}
